import { render, staticRenderFns } from "./clientes-vinculados.vue?vue&type=template&id=0fc96458&scoped=true&"
import script from "./clientes-vinculados.vue?vue&type=script&lang=js&"
export * from "./clientes-vinculados.vue?vue&type=script&lang=js&"
import style0 from "./clientes-vinculados.vue?vue&type=style&index=0&id=0fc96458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc96458",
  null
  
)

export default component.exports